import React from "react";
import { useTaskTimer } from "../hooks/useTaskTimer";
import { lang } from "../lang";

// Component for rendering daily tasks with timers and streaks
function DailyTasksModule({ dailyTasks, onUpdateTask, autoCompleteOnTimer }) {
  if (!dailyTasks || dailyTasks.length === 0) return null;

  const formatTime = (seconds) => {
    const validSeconds = Number.isFinite(seconds) ? seconds : 1800;
    const hours = Math.floor(validSeconds / 3600);
    const minutes = Math.floor((validSeconds % 3600) / 60);
    const secs = Math.floor(validSeconds % 60);
    return `${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div
      className="daily-tasks-module"
      style={{
        display: "flex",
        overflowX: "auto",
        margin: "10px 0",
        padding: "10px",
        background: "#f0f0f0",
        borderRadius: "5px",
      }}
    >
      {dailyTasks
        .filter((task) => task.isActiveToday)
        .map((task) => {
          const { displayRemaining } = useTaskTimer(
            task,
            onUpdateTask,
            autoCompleteOnTimer
          );
          return (
            <div
              key={task.id}
              className="daily-task"
              style={{
                margin: "0 10px",
                padding: "10px",
                background: "#e6f0ff",
                borderRadius: "5px",
                minWidth: "200px",
                textAlign: "center",
              }}
            >
              <div style={{ fontWeight: "bold" }}>{task.name}</div>
              {task.streak > 0 && (
                <div
                  className="streak-badge"
                  style={{
                    display: "inline-block",
                    background: "#ff4500",
                    color: "#fff",
                    padding: "2px 8px",
                    borderRadius: "10px",
                    margin: "5px 0",
                    fontSize: "12px",
                  }}
                >
                  Streak: {task.streak}
                </div>
              )}
              <div className="timer">
                {formatTime(displayRemaining ?? task.duration)}
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default DailyTasksModule;
